import { ApiError, ErrorResponseDto } from '@pro4-erp/core-web';
import { apiFetch } from '@/core';
import env from '@/env';
import { ContactWithAction, WorkOrderContact } from '../types';

export const updateWOContact = async ({
  data,
}: {
  data: ContactWithAction;
}): Promise<WorkOrderContact> => {
  console.log(data);
  const fetchResponse = await apiFetch(
    `${env.VITE_API_URL}/pb/s/api/sqo-portal/sqo-work-order-contact-proposal/${data.wo_id}/${data.id}`,
    {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    }
  );

  if (!fetchResponse.ok) {
    const error = (await fetchResponse.json()) as ErrorResponseDto;
    throw new ApiError(error);
  }

  const response = (await fetchResponse.json()) as WorkOrderContact;
  return response;
};
